import {FaqDto, MenuDto} from "../../services/Client";
import {AnyAction, Dispatch} from "redux";
import {ActionTypes} from "./ActionTypes";
import {IReduxState} from "../IReduxState";
import {renderErrorToast} from "../../utils/FeedbackMessageUtils";
import GeneralActions from "./GeneralActions";

const SupportViewActions = {
    RequestSupportAreaLinks(baseLinks: MenuDto | undefined) {
        return (dispatch: Dispatch<IReduxState>, getState: () => IReduxState) => {
            const {client} = getState().general;

            if (!baseLinks || !client.GET_supportArea(baseLinks).canExecute()) {
                return;
            } else {
                client.GET_supportArea(baseLinks).execute()
                    .then((supportAreaLinks: MenuDto) =>
                        dispatch(this.ReceiveSupportareaLinks(supportAreaLinks)
                        ))
                    .catch((reason: any) => {
                        window.scrollTo(0, 0);
                        renderErrorToast({
                            message: "ERRORS:GET_SUPPORT_AREA_LINKS",
                            details: reason,
                            timestamp: Date.now()
                        });
                    });
            }
        };
    },

    ReceiveSupportareaLinks(dto: MenuDto): AnyAction {
        return {type: ActionTypes.RECEIVE_SUPPORTAREA_LINKS, supportAreaLinks: dto};
    },

    GetActiveFaqs(t: reactI18Next.TranslationFunction) {
        return (dispatch: Dispatch<IReduxState>, getState: () => IReduxState) => {
            const {client} = getState().general;
            const {supportAreaLinks} = getState().support;

            if (!supportAreaLinks || !client.GET_activeFaq(supportAreaLinks).canExecute()) {
                renderErrorToast({
                                     message: "GLOBAL:MISSING_ACCESS_RIGHTS",
                                     details: "ERRORS:GET_ACTIVE_FAQ",
                                     timestamp: Date.now()
                                 }
                );
            } else {
                const loadingScreenMessage = t('SUPPORT_FAQ:GET_ACTIVE_FAQS');
                dispatch(GeneralActions.AddLoadingMessage(loadingScreenMessage));
                client.GET_activeFaq(supportAreaLinks).execute()
                    .then((result: FaqDto[]) => {
                        dispatch(this.ReceiveActiveFaqs(result));
                        dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                    }).catch((reason) => {
                    dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                    renderErrorToast({
                                         message: "ERRORS:GET_ACTIVE_FAQS",
                                         details: reason,
                                         timestamp: Date.now()
                                     }
                    );
                });
            }
        };
    },
    ReceiveActiveFaqs(activeFaqs: FaqDto[]) {
        return {type: ActionTypes.RECEIVE_ACTIVE_FAQS, activeFaqs};
    }
};

export default SupportViewActions;



// WEBPACK FOOTER //
// ./src/redux/actions/SupportViewActions.tsx